export class ResponseMessageModel {
  isError: boolean;
  message: string;
}
